import { Controller } from "@hotwired/stimulus"

// Disables a submit button until at least one checkbox is checked.
// Usage: data-controller="checkbox-submit"
//        data-checkbox-submit-target="checkbox" on each checkbox
//        data-checkbox-submit-target="submit" on the button
export default class CheckboxSubmitController extends Controller {
  static targets = ["checkbox", "submit"]

  declare readonly checkboxTargets: HTMLInputElement[]
  declare readonly submitTarget: HTMLButtonElement

  connect() {
    this.update()
  }

  update() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked)
    this.submitTarget.disabled = !anyChecked
  }
}
